import React, { useEffect, useState } from 'react';
import { Typography } from '@telus-uds/components-web';
import {
  Table,
  Td,
  Th,
  Tr
} from '../../quoteSummary/componets/css';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import { getLocale } from '../../../misc';

const CodeBasedPromotions = ({orderData,isVulcanOrder}) => {

  const locale = getLocale();

  const {
    vulcanWebform: {
      _couponCode,
      _discountAmount,
      _duration,
      _validateCode
    }
  } = locale === 'en-US' ? EN : FR;

   const {
        redeemOfferData:{redeemOfferSelection}
    } = orderData;

  const [redeemOfferData, setRedeemOfferData] = useState(redeemOfferSelection);


  return (
    <div>
      {redeemOfferData && !!redeemOfferData.length && (
        <Table>
          <Th><Typography>{isVulcanOrder ? 'Coupon Code' : _couponCode}</Typography></Th>
          <Th><Typography>{isVulcanOrder ? 'Validation Code' : _validateCode}</Typography></Th>
          <Th><Typography>{isVulcanOrder ? 'Discount Amount' : _discountAmount}</Typography></Th>
          <Th><Typography>{isVulcanOrder ? 'Duration' : _duration}</Typography></Th>
          {/* Add this column for edit/delete buttons */}
          {redeemOfferData.map(
            (
              { couponCode, validationCode, promotionAmount, duration },
              idx
            ) => (
              <Tr key={`${idx}`}>
                <Td><Typography>{couponCode}</Typography></Td>
                <Td><Typography>{validationCode}</Typography></Td>
                <Td><Typography>{promotionAmount}</Typography></Td>
                <Td><Typography>{duration}</Typography></Td>
                
              </Tr>
            )
          )}
          
        </Table>
      )}
     
    </div>
  );
};

export default CodeBasedPromotions;
